import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import signin from "../../assets/img/signin.svg";
import { Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { userForgotPassword, userForgotPasswordView, verifyOtp } from '../../Redux/Auth';
import { useState } from 'react';
import ToasterMessage from '../ToasterMessage';
import loader from '../../assets/img/loader.gif';

const ForgotPassword = () => {

    const [isloader, setIsloader] = useState(false);
    const [newpassword, setNewPassword] = useState(false);
    const [confirmpassword, setConfirmPassword] = useState(false);
    const [switchbutton, setSwicthbutton] = useState("Phone");
    const [toaster, setToaster] = useState("");
    const viewPassword = () => {
        setNewPassword(!newpassword);
    }
    const viewConfirmPassword = () => {
        setConfirmPassword(!confirmpassword);
    }

    const navigate = useNavigate();


    const validationSchema = Yup.object().shape({
        // username: Yup.string()
        //     .required('Required'),
        // password: Yup.string()
        //     .required('Required'),
        // phone: Yup.string()
        //     .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            phone: "",
            type_of_user: "1",
            otp: "",
            password: "",
            confirm_password: "",
        },
        validationSchema,
        onSubmit: (values) => {
            __formSubmit(values)
        },
    });
    const __formSubmit = (values) => {
        // let formData = new FormData();    //formdata object
        // formData.append("phone", values.phone);
        // formData.append("type_of_user", values.type_of_user);
        setIsloader(true)
        userForgotPassword(values.phone, values.type_of_user)((response) => {
            if (response && response.status) {
                setIsloader(false)
                localStorage.setItem('refresh_token', response.data.refresh);
                localStorage.setItem('token_temp', response.data.token);
                setSwicthbutton("OTP");
            }
            else {
                setIsloader(false)
                // setError(response.response.data)
            }
        });
    };
    const __onVerifyOtp = () => {
        setIsloader(true)
        localStorage.setItem('token', localStorage.getItem('token_temp'))
        localStorage.removeItem('token_temp')
        verifyOtp(formik.values.otp, "")((response) => {
            if (response.status) {
                setIsloader(false)
                setSwicthbutton("NewPass")
                // setShowOtp(false)
                // navigate("/");
                localStorage.setItem('token_temp', localStorage.getItem('token'))
                localStorage.setItem('user_name', response.data.user_name)
                localStorage.removeItem('token')

            }
            else {
                setIsloader(true)
                // setOtpError(response.response.data.message)
            }

        });

    }

    const __confirmPassword = () => {
        if (formik.values.password === formik.values.confirm_password) {
            localStorage.setItem('token', localStorage.getItem('token_temp'))
            localStorage.removeItem('token_temp')
            setIsloader(true)
            userForgotPasswordView(formik.values.phone, formik.values.type_of_user, formik.values.password, formik.values.confirm_password)((response) => {
                if (response && response.status) {
                    setIsloader(false)
                    // localStorage.setItem('refresh_token', response.data.refresh);
                    // localStorage.setItem('token', response.data.token);
                    localStorage.removeItem('token')
                    navigate('/signin')
                }
                else {
                    setIsloader(true)
                    // setError(response.response.data)
                }
            });
        }
        else {
            setToaster("Mismatch")
            setTimeout(() => {
                setToaster("")

            }, 2000);
        }
    }


    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Sign In </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Sign In</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="signinpage">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={signin} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="login-wrap">
                                <div className="">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="signintitle">
                                                <h1 className='ms-5'>Reset your password</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='login-html login-form'>

                                    {switchbutton === "Phone" ?
                                        <React.Fragment>
                                            <Form onSubmit={formik.handleSubmit}>

                                                <div class="switches-container mb-4">
                                                    <input type="radio" id="switchMonthly" name="type_of_user" onChange={formik.handleChange} value="1" checked={formik?.values?.type_of_user == 1 ? true : false} />
                                                    <input type="radio" id="switchYearly" name="type_of_user" onChange={formik.handleChange} value="2" checked={formik?.values?.type_of_user == 2 ? true : false} />
                                                    <label for="switchMonthly">Buyer</label>
                                                    <label for="switchYearly">Seller</label>
                                                    <div class="switch-wrapper">
                                                        <div class="switch">
                                                            <div>Buyer</div>
                                                            <div>Seller</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Mobile Number <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        name='phone'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.phone && !formik.errors.phone}
                                                        isInvalid={!!formik.errors.phone}
                                                        maxLength="255"
                                                        placeholder='Enter Mobile Number'
                                                        required
                                                        value={formik.values.phone}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.phone}</Form.Control.Feedback>
                                                </Form.Group>
                                                <div className="group">
                                                    {isloader == true ?
                                                        <div className='loader'>
                                                            <img src={loader} alt="" />
                                                        </div>
                                                        :
                                                        <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" >Submit</Button>
                                                    }
                                                </div>
                                            </Form>
                                        </React.Fragment>
                                        :
                                        switchbutton === "OTP" ?
                                            <React.Fragment>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Enter OTP <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        name='otp'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.otp && !formik.errors.otp}
                                                        isInvalid={!!formik.errors.otp}
                                                        maxLength="255"
                                                        placeholder='Enter OTP'
                                                        required
                                                        value={formik.values.otp}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.otp}</Form.Control.Feedback>
                                                </Form.Group>
                                                <div className="group">
                                                    {isloader == true ?
                                                        <div className='loader'>
                                                            <img src={loader} alt="" />
                                                        </div>
                                                        :
                                                        <Button type="button" className="btn btn-primary next-btn mt-3 mb-3" onClick={() => __onVerifyOtp()}>Submit</Button>
                                                    }
                                                </div>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>New Password <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        name='password'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.password && !formik.errors.password}
                                                        isInvalid={!!formik.errors.password}
                                                        maxLength="255"
                                                        placeholder='Enter new password'
                                                        required
                                                        type={newpassword ? "text" : "password"}
                                                        value={formik.values.password}
                                                    />
                                                    <div className='icon-eye'>
                                                        {newpassword ?
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewPassword() }} className="bi bi-eye" viewBox="0 0 16 16">
                                                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                            </svg>
                                                            :
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewPassword() }} className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                            </svg>
                                                        }
                                                    </div>
                                                    <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Confirm Password <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        name='confirm_password'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.confirm_password && !formik.errors.confirm_password}
                                                        isInvalid={!!formik.errors.confirm_password}
                                                        maxLength="255"
                                                        placeholder='Enter confirm password'
                                                        required
                                                        type={confirmpassword ? "text" : "password"}
                                                        value={formik.values.confirm_password}
                                                    />
                                                    <div className='icon-eye'>
                                                        {confirmpassword ?
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewConfirmPassword() }} className="bi bi-eye" viewBox="0 0 16 16">
                                                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                            </svg>
                                                            :
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewConfirmPassword() }} className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                            </svg>
                                                        }
                                                    </div>
                                                    <Form.Control.Feedback type="invalid">{formik.errors.confirm_password}</Form.Control.Feedback>
                                                </Form.Group>
                                                <div className="group">
                                                    {isloader == true ?
                                                        <div className='loader'>
                                                            <img src={loader} alt="" />
                                                        </div>
                                                        :
                                                        <Button type="button" className="btn btn-primary next-btn mt-3 mb-3" onClick={() => __confirmPassword()}>Submit</Button>
                                                    }
                                                </div>
                                            </React.Fragment>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment >
    )
}

export default ForgotPassword;